export default __webpack_public_path__ + "static/media/pixellab--og--privacy.6f70b2b8.jpg";